module.exports = __webpack_public_path__ + "assets/drift.ef15032e.svg";